import clsx from 'clsx'
import type { ReactNode } from 'react'
import { View, type ViewProps } from 'react-native'

import { placeholderMedia, type TPlaceholderMediaVariantProps } from './PlaceholderMedia.variant'

type TPlaceholderMediaProps = ViewProps & TPlaceholderMediaVariantProps

export const PlaceholderMedia = ({ className, ...rest }: TPlaceholderMediaProps): ReactNode => (
  <View className={clsx(placeholderMedia(rest), 'overflow-hidden', className)}>
    <View className="rounded-2xl" />
  </View>
)
